import styled, { css } from 'styled-components'

export const Text = styled.div`
  position: absolute;
  ${({ theme }) => theme.typography.body1}
`

export const Sup = styled.sup`
  ${({ theme }) => theme.typography.smallText2};
  opacity: 0.8;
`

export const Stat = styled.div<{ left?: boolean }>`
  position: absolute;
  color: ${({ theme }) => theme.palette.text.primary};
  ${({ theme }) => theme.typography.body2};
  bottom: 0;

  ${({ left }) =>
    left
      ? css`
          left: 0.5rem;
        `
      : css`
          right: 0.5rem;
        `}
`

export const StatCardWrapper = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  position: relative;
  ${({ theme }) => theme.typography.smallText2};
  height: 100px;
  width: 188px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: 0 0 0 1px ${({ theme }) => theme.palette.border.light};
  border-radius: 4px;
  margin: 1rem;

  ${Text} {
    top: 6px;
    right: ${({ theme }) => theme.spacing(1)};
  }
`

export const IconBox = styled.div<{
  variant: 'Speed' | 'Accuracy' | 'Duration' | 'uppercase' | 'lowercase' | 'number' | 'symbols'
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 70px;
  border-radius: 3px;
  position: absolute;
  top: -1rem;
  left: 0.75rem;
  box-shadow: 0 6px 10px hsla(0, 0%, 66.7%, 0.15);

  ${({ variant }) =>
    variant === 'Speed' &&
    css`
      background-color: #006bf4;
    `}
  ${({ variant }) =>
    variant === 'Accuracy' &&
    css`
      background-color: #00b2c5;
    `}
  ${({ variant }) =>
    variant === 'Duration' &&
    css`
      background-color: #a9834f;
    `};
`

export const LetterBox = styled.div<{ color: string }>`
  background-color: ${({ color }) => color && color};
  width: 4.875rem;
  height: 2.1875rem;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  box-shadow: 6px 0 10px hsla(0, 0%, 66.7%, 0.15);
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  color: #fff;
  ${({ theme }) => theme.typography.body2};
`

export const SelectionIndicator = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    margin-right: ${({ theme }) => theme.spacing(0.875)};
  }
`

export const TallCard = styled.div`
  position: relative;
  width: 10rem;
  height: 11.5rem;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: 0 0 0 1px ${({ theme }) => theme.palette.border.light};
  border-radius: 4px;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => theme.typography.smallText};
  color: ${({ theme }) => theme.palette.text.primary};
  margin: 1rem;

  ${Text} {
    text-transform: capitalize;
    padding: 0 ${({ theme }) => theme.spacing(2)};
    text-align: center;
    width: 100%;
    top: 2rem;
    &:nth-last-child(2) {
      top: 8.5rem;
    }
  }

  ${Stat} {
    top: 5rem;
    left: 50%;
    transform: translateX(-50%);
  }

  ${SelectionIndicator} {
    bottom: 1rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
